import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";
import { StyledText } from "../assets/typography/typography";
import { colors } from "./colors";

interface DropdownNavigationProps {
  children: React.ReactNode;
  toggleTitle: string;
  isActive: boolean;
}

export const DropdownNavigation = ({
  children,
  toggleTitle,
  isActive,
}: DropdownNavigationProps) => {
  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
  const [backgroundColor, setBackgroundColor] = useState<string>(
    colors.transparent
  );

  useEffect(() => {
    if (isActive) {
      setBackgroundColor(colors.ctaLight);
    } else {
      setBackgroundColor(colors.transparent);
    }
  }, [isActive]);

  const handleToggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  return (
    <Dropdown isOpen={dropdownOpen} toggle={handleToggleDropdown}>
      <DropdownToggle
        caret={false}
        className="d-flex align-items-center justify-content-center px-4 py-3 bodyTextRegular mb-0"
        style={{
          gap: "8px",
          border: "none",
          boxShadow: "none",
          backgroundColor: backgroundColor,
          color: `${
            dropdownOpen || isActive ? colors.ctaMain : colors.textPrimary
          }`,
        }}
        onMouseEnter={() => {
          if (!isActive) {
            setBackgroundColor(colors.ctaLight);
          }
        }}
        onMouseLeave={() => {
          if (!isActive) {
            setBackgroundColor(colors.transparent);
          }
        }}
      >
        <StyledText
          className={`${
            dropdownOpen || isActive ? "bodyTextSemibold" : "bodyTextRegular"
          } mb-0`}
        >
          {toggleTitle}
        </StyledText>
        <FontAwesomeIcon icon={solid("chevron-down")} />
      </DropdownToggle>
      <DropdownMenu
        right={true}
        className="py-0"
        style={{ borderRadius: "4px" }}
      >
        {children}
      </DropdownMenu>
    </Dropdown>
  );
};
